import { GenericResponseModel, LoginRequest, changePassworRequestModel } from "../dataModel/authModels";
import { ApiRoutes } from "./apiConfig/apiEdndpoints";
import { customAxios } from "./apiConfig/useExPressApi";

export const auth = {
  login: (data: LoginRequest) => {
    return customAxios.post<any, GenericResponseModel>(`${ApiRoutes.LOGIN}`, data);
  },
  loginSession: () => {
    return customAxios.get(`${ApiRoutes.GET_CLIENT}`);
  },
  forgotPassword: (username: string) => {
    return customAxios.get(`${ApiRoutes.FORGOT_PASSWORD}${username}`);
  },
  changePassword: (data: changePassworRequestModel) => {
    return customAxios.post(`${ApiRoutes.CHANGE_PASSWORD}`, data);
  },
  linkedAccounts: () => {
    return customAxios.get(`${ApiRoutes.GET_LINKED_ACCOUNTS}`);
  },
  switchClient: (clientIds:string) => {
    return customAxios.post(`${ApiRoutes.SWITCH_CLIENT}${clientIds}`,);
  },
  getParentInfo: () => {
    return customAxios.get(`${ApiRoutes.GET_PARENT_INFO}`);
  },
  getClientQuestionnaires: (data: any) => {
    return customAxios.post(`${ApiRoutes.GET_CLIENT_QUESTIONNAIRES}`, data);
  },

  
}